import {Platform} from '@ionic/angular';
import {inject, Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly platform = inject(Platform);

    isDesktop = false;
    heightPlatform!: number;
    notWeb = true;
    responsiveSize = 0;
    typeDevice = 0;

    async init(): Promise<void> {
        await this.platform.ready();
        this.calc();
        // aggiorna su resize/orientamento
        window.addEventListener('resize', () => this.calc());
    }

    private calc() {
        const w = this.platform.width?.() ?? window.innerWidth;
        const h = this.platform.height?.() ?? window.innerHeight;

        this.notWeb   = !this.platform.is('mobileweb') && !this.platform.is('desktop') && !this.platform.is('pwa');
        this.typeDevice = this.platform.is('android') ? 1 : this.platform.is('ios') ? 2 : 0;
        this.isDesktop  = this.platform.is('desktop') && !this.platform.is('android') && !this.platform.is('ios');

        this.heightPlatform = h;
        this.responsiveSize = w >= 1200 ? 3 : w >= 992 ? 2 : w >= 768 ? 1 : 0;
    }
}
